import { render, staticRenderFns } from "./approvals.vue?vue&type=template&id=be1a790a&scoped=true"
import script from "./approvals.vue?vue&type=script&lang=js"
export * from "./approvals.vue?vue&type=script&lang=js"
import style0 from "./approvals.vue?vue&type=style&index=0&id=be1a790a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1a790a",
  null
  
)

export default component.exports